import cn from "classnames";
import type { FC } from "react";
import styles from "./LineTypeMenu.module.css";

interface LineTypeButtonProps<Value> {
    value: Value;
    selectedValue: Value;
    onClick: (value: Value) => void;
    Icon: FC;
}

export function LineTypeButton<Value>({
    value,
    selectedValue,
    onClick,
    Icon,
}: LineTypeButtonProps<Value>) {
    const handleClick = () => {
        onClick(value);
    };

    const buttonStyles = cn(styles.button, value === selectedValue && styles.selected);

    return (
        <button className={buttonStyles} type="button" onClick={handleClick}>
            <Icon />
        </button>
    );
}
